import {forwardRef} from "@angular/core";
import {APIProxy} from "./api.proxy";
import {ConfProxy} from "./conf.proxy";
//import {ScriptsLoader} from "./scripts.loader";
import {HttpDataPovider} from "./user.ctx.token";
import {URLUtilService} from "./url.util.service";


export {APIProxy} from "./api.proxy";
export {ConfProxy} from "./conf.proxy";

export {HttpObservable} from "./http.wrapper";

export const HTTP_PROVIDERS = [
	APIProxy,
	ConfProxy,
	HttpDataPovider,
//	ScriptsLoader,
	URLUtilService];//TODO:check this

export * from './conf.proxy';
